/*eslint-disable */
import { bus } from '@/main';
import toast from '@/services/toast';
export default {
  name: 'meeting-remove-popup',
  components: {},
  props: ['removeMeetingID'],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    closedRemoveMeetingPopup(){
      bus.$emit('removeMeetingPopupBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    removeMeetingConfirmationMethod(){
      let data  = {
        is_deleted:true
      }
      this.$store.dispatch('updateMeetingDetailsFun', 
      {
        data: {
          data: data,
          id: this.removeMeetingID
        }
      }).then((res)=>{
        this.getMeetingListAgain()
        this.closedRemoveMeetingPopup()
      })
    },
    getMeetingListAgain(){
      this.$store.dispatch('getMeetingAllListFun')
    },
  }
}